/*
 * Vaillant WhatsApp opt-in popup (section wa-optin-popup). Vanilla JS, no dependency.
 *
 * When it shows: after N seconds of visible time cumulated over the visit, or on exit
 * intent (desktop), at most once every N days per browser, never again after a click
 * on the CTA, never on cart / checkout / account pages, never for visitors coming
 * from WhatsApp (utm containing whatsapp or wax), never when a discount code is
 * already applied. It waits while the cart drawer, a menu, Crisp or a cookie banner
 * is open.
 *
 * Events (no extra script): dataLayer.push and Shopify.analytics.publish with
 * wa_popup_view, wa_popup_click, wa_popup_close, wa_popup_expand (C),
 * wa_popup_spin (D) and wa_popup_scratch (E).
 *
 * Designs D (wheel) and E (scratch card) load wa-optin-game.js, which runs the draw.
 *
 * QA: ?wa_popup=show (opens after 1 s, nothing stored, no event),
 *     &wa_popup_variant=a|b|c|d|e, ?wa_popup=reset (clears this browser's flags).
 */
(function () {
  'use strict';

  var KEY_CLICKED = 'vwa:clicked';
  var KEY_SUPPRESS = 'vwa:suppress-until';
  var KEY_LAST = 'vwa:last:';
  var SKEY_TIME = 'vwa:visible-ms';
  var SKEY_TEASER = 'vwa:teaser';
  var DESKTOP_QUERY = '(min-width: 768px) and (hover: hover) and (pointer: fine)';
  var DAY = 86400000;
  var FROM_WHATSAPP_DAYS = 30;

  var store = {
    get: function (area, key) {
      try { return window[area].getItem(key); } catch (e) { return null; }
    },
    set: function (area, key, value) {
      try { window[area].setItem(key, value); } catch (e) { /* storage blocked */ }
    },
    remove: function (area, key) {
      try { window[area].removeItem(key); } catch (e) { /* storage blocked */ }
    }
  };

  function isVisible(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.05;
  }

  function anyVisible(selector, minSize) {
    var nodes;
    try { nodes = document.querySelectorAll(selector); } catch (e) { return false; }
    for (var i = 0; i < nodes.length; i++) {
      if (!isVisible(nodes[i])) continue;
      if (!minSize) return true;
      var r = nodes[i].getBoundingClientRect();
      if (r.width >= minSize && r.height >= minSize) return true;
    }
    return false;
  }

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP_QUERY).matches;
  }

  function fromWhatsApp(params) {
    var keys = ['utm_source', 'utm_medium', 'utm_campaign'];
    for (var i = 0; i < keys.length; i++) {
      var v = (params.get(keys[i]) || '').toLowerCase();
      if (v.indexOf('whatsapp') !== -1 || v.indexOf('wax') !== -1) return true;
    }
    return /(^|[?&])(wa_optin|wax_[a-z_]+)=/i.test(window.location.search);
  }

  function hasDiscountCookie() {
    return /(^|;\s*)discount_code=[^;]+/.test(document.cookie);
  }

  function excludedPath() {
    return /^\/(cart|checkout|checkouts|account)(\/|$)/.test(window.location.pathname) ||
      /\/(checkouts|orders)\//.test(window.location.pathname);
  }

  function init(root) {
    if (!root || root.__vwa) return null;
    var configEl = root.querySelector('[data-vwa-config]');
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return null; }

    var params = new URLSearchParams(window.location.search);
    var qa = (params.get('wa_popup') || '').toLowerCase();
    var preview = qa === 'show';
    var designMode = !!config.designMode || !!(window.Shopify && window.Shopify.designMode);
    var quiet = preview || designMode; // no storage writes, no tracking

    if (qa === 'reset') {
      try {
        Object.keys(window.localStorage).forEach(function (k) {
          if (k.indexOf('vwa:') === 0) store.remove('localStorage', k);
        });
      } catch (e) { /* storage blocked */ }
      store.remove('sessionStorage', SKEY_TIME);
      store.remove('sessionStorage', SKEY_TEASER);
    }

    var variant = config.variant;
    var forced = (params.get('wa_popup_variant') || '').toLowerCase();
    if (preview && /^[a-e]$/.test(forced)) {
      variant = forced;
      root.className = root.className.replace(/\bvwa--[a-e]\b/, 'vwa--' + forced);
    }
    var isGame = variant === 'd' || variant === 'e';
    root.classList.toggle('vwa--game', isGame);

    var dialog = root.querySelector('.vwa__dialog');
    var teaser = document.querySelector('[data-vwa-teaser]');
    var qrBox = root.querySelector('[data-vwa-qr]');
    var webLink = root.querySelector('[data-vwa-web]');
    var lastKey = KEY_LAST + (config.campaign || 'wa');
    var state = { open: false, teaser: false, viewed: false, fired: false, lastFocus: null, timers: [], listeners: [], qrDone: false, game: null, prize: null };

    // WhatsApp Web link: explicit setting, else phone + message, else the main link.
    var phone = String(config.phone || '').replace(/\D/g, '');
    var webHref = (config.webLink || '').trim();
    if (!webHref && phone && config.message) {
      webHref = 'https://web.whatsapp.com/send?phone=' + phone + '&text=' + encodeURIComponent(config.message);
    }
    if (webHref && webLink) webLink.setAttribute('href', webHref);

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      state.listeners.push([target, type, fn, opts]);
    }

    function later(fn, ms) {
      var id = window.setTimeout(fn, ms);
      state.timers.push(id);
      return id;
    }

    function track(name, extra) {
      if (quiet) return;
      var payload = {
        wa_popup_variant: variant,
        wa_popup_campaign: config.campaign,
        wa_popup_surface: isDesktop() ? 'desktop' : 'mobile',
        page_type: config.pageType
      };
      if (state.prize) payload.wa_popup_prize = state.prize.label;
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
      try {
        window.dataLayer = window.dataLayer || [];
        var dl = { event: name };
        for (var p in payload) dl[p] = payload[p];
        window.dataLayer.push(dl);
      } catch (e) { /* ignore */ }
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, payload);
        }
      } catch (e) { /* ignore */ }
    }

    function loadScript(src, onload, onerror) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = onload;
      s.onerror = onerror;
      document.head.appendChild(s);
    }

    // Draws the QR code of `text` (desktop only). The encoder is loaded on first use.
    function renderQr(text) {
      if (!qrBox || !isDesktop() || !text) return;
      var draw = function () {
        try {
          var svg;
          try {
            svg = window.VaillantQR.svg(text, { ecl: 'M' });
          } catch (tooLong) {
            svg = window.VaillantQR.svg(text, { ecl: 'L' });
          }
          qrBox.innerHTML = svg;
          qrBox.style.display = '';
        } catch (err) {
          qrBox.style.display = 'none';
        }
      };
      if (window.VaillantQR) return draw();
      loadScript(config.qrScript, draw, function () { qrBox.style.display = 'none'; });
    }

    function loadQr() {
      // Games draw the QR of the prize message once it is revealed.
      if (state.qrDone || isGame) return;
      state.qrDone = true;
      renderQr(config.link);
    }

    function blocked() {
      if (document.querySelector('cart-drawer.active, cart-drawer.is-open, cart-notification.active')) return true;
      if (/(^|\s)overflow-hidden/.test(document.body.className)) return true;
      if (document.querySelector('details[open] > .menu-drawer, details[open] > .search-modal, product-modal[open]')) return true;
      try {
        if (window.$crisp && typeof window.$crisp.is === 'function' && window.$crisp.is('chat:opened')) return true;
      } catch (e) { /* ignore */ }
      // Cookie banners (Consentmo, Shopify native) and third-party cart drawers (Upcart).
      if (anyVisible('#shopify-pc__banner, [id*="consentmo" i], [class*="consentmo" i], .isense-cc-window, #cookie-banner, .cc-window')) return true;
      if (anyVisible('[id*="upcart" i], [class*="upcart-drawer" i]', 200)) return true;
      var dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"], dialog[open]');
      for (var i = 0; i < dialogs.length; i++) {
        if (!root.contains(dialogs[i]) && isVisible(dialogs[i])) return true;
      }
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
      return false;
    }

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
        function (el) { return isVisible(el); }
      );
    }

    function onKeydown(e) {
      if (!state.open) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close('escape');
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); dialog.focus(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    // First display of this visit: counts for the frequency cap and fires the view event.
    function registerView(trigger, format) {
      if (state.viewed) return false;
      state.viewed = true;
      if (!quiet) store.set('localStorage', lastKey, String(Date.now()));
      track('wa_popup_view', { wa_popup_trigger: trigger, wa_popup_format: format });
      return true;
    }

    function open(reason) {
      if (state.open) return;
      state.open = true;
      state.lastFocus = document.activeElement;
      if (teaser) {
        teaser.hidden = true;
        teaser.classList.remove('is-in');
      }
      loadQr();
      root.hidden = false;
      document.documentElement.classList.add('vwa-open');
      if (state.game && state.game.onOpen) state.game.onOpen();
      // Next frame so the entrance transition runs.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          root.classList.add('is-open');
          dialog.focus({ preventScroll: true });
        });
      });
      if (!registerView(reason || 'timer', 'popup')) {
        track('wa_popup_expand', { wa_popup_trigger: reason || 'teaser' });
      }
    }

    function close(method, keepTeaser) {
      if (!state.open) return;
      state.open = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('vwa-open');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      later(function () {
        if (!state.open) root.hidden = true;
      }, reduce ? 0 : 380);
      // Variant C: closing the card folds it back into the tab, unless the visitor said no.
      var backToTeaser = variant === 'c' && state.teaser && keepTeaser !== false && method !== 'dismiss' && method !== 'cta';
      if (backToTeaser) {
        showTeaser(true);
      } else {
        state.teaser = false;
        if (!quiet) store.remove('sessionStorage', SKEY_TEASER);
      }
      var focusTarget = backToTeaser ? teaser.querySelector('[data-vwa-teaser-open]') : state.lastFocus;
      if (focusTarget && typeof focusTarget.focus === 'function' && method !== 'cta') {
        try { focusTarget.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      if (method !== 'cta') track('wa_popup_close', { wa_popup_close_method: method });
    }

    function showTeaser(silent) {
      if (!teaser) return open('timer');
      state.teaser = true;
      teaser.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { teaser.classList.add('is-in'); });
      });
      if (!silent) {
        if (!quiet) store.set('sessionStorage', SKEY_TEASER, '1');
        registerView('timer', 'teaser');
      }
      if (isDesktop()) loadQr();
    }

    function hideTeaser(method) {
      if (!teaser) return;
      teaser.classList.remove('is-in');
      teaser.hidden = true;
      state.teaser = false;
      if (!quiet) store.remove('sessionStorage', SKEY_TEASER);
      track('wa_popup_close', { wa_popup_close_method: method, wa_popup_format: 'teaser' });
    }

    function trigger(reason) {
      if (state.open || state.fired) return;
      if (blocked()) {
        later(function () { trigger(reason); }, 2000);
        return;
      }
      state.fired = true;
      window.clearInterval(state.ticker);
      if (variant === 'c' && reason !== 'exit') {
        showTeaser(false);
      } else {
        if (variant === 'c' && teaser) {
          // Exit intent opens the card directly; the tab takes over once it is closed.
          state.teaser = true;
          if (!quiet) store.set('sessionStorage', SKEY_TEASER, '1');
        }
        open(reason);
      }
    }

    // Wiring: close buttons, backdrop, CTA, teaser.
    on(root, 'click', function (e) {
      var closer = e.target.closest('[data-vwa-close]');
      if (closer) {
        e.preventDefault();
        close(closer.getAttribute('data-vwa-close'));
        return;
      }
      var cta = e.target.closest('[data-vwa-cta]');
      if (cta) {
        // Shopify injects an exit interstitial ("Vous quittez Vaillant Parfums", /url?q=...)
        // on every link to another domain. It stands aside when page code handles the click,
        // so the WhatsApp link is opened here directly. If the browser blocks the new tab,
        // the normal link (and the interstitial) still work as a fallback.
        var href = cta.getAttribute('href');
        var win = null;
        if (href && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
          try { win = window.open(href, '_blank'); } catch (err) { win = null; }
        }
        if (win) {
          try { win.opener = null; } catch (err) { /* ignore */ }
          e.preventDefault();
        }
        if (!quiet) store.set('localStorage', KEY_CLICKED, new Date().toISOString());
        track('wa_popup_click', { wa_popup_target: cta.getAttribute('data-vwa-cta') });
        // Let the link open (new tab or WhatsApp app), then fold the popup away.
        later(function () { close('cta', false); }, 300);
      }
    });
    on(root.querySelector('.vwa__backdrop'), 'wheel', function (e) { e.preventDefault(); }, { passive: false });
    on(document, 'keydown', onKeydown);
    if (teaser) {
      on(teaser, 'click', function (e) {
        if (e.target.closest('[data-vwa-teaser-close]')) {
          hideTeaser('teaser_close');
        } else if (e.target.closest('[data-vwa-teaser-open]')) {
          open('teaser');
        }
      });
    }

    // Designs D and E: the game module renders the wheel or the ticket and runs the draw.
    if (isGame) {
      var gameApi = {
        root: root,
        dialog: dialog,
        config: config,
        variant: variant,
        quiet: quiet,
        isDesktop: isDesktop,
        isOpen: function () { return state.open; },
        track: track,
        renderQr: renderQr,
        load: function (key) { return store.get('localStorage', key); },
        save: function (key, value) { if (!quiet) store.set('localStorage', key, value); },
        // Points every exit of the popup at the WhatsApp message of the prize.
        setPrize: function (prize) {
          state.prize = prize;
          var text = prize.message || '';
          var waUrl = phone ? 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text) : config.link;
          Array.prototype.forEach.call(root.querySelectorAll('.vwa__cta, .vwa__composer'), function (a) {
            a.setAttribute('href', prize.link || waUrl);
          });
          if (webLink && phone) webLink.setAttribute('href', 'https://web.whatsapp.com/send?phone=' + phone + '&text=' + encodeURIComponent(text));
          var field = root.querySelector('.vwa__composer-field');
          if (field) field.textContent = text;
          renderQr(phone ? waUrl : (prize.link || config.link));
        }
      };
      var mountGame = function () {
        if (!window.VaillantWaGame || state.game) return;
        state.game = window.VaillantWaGame.mount(gameApi);
        if (state.open && state.game && state.game.onOpen) state.game.onOpen();
      };
      if (window.VaillantWaGame) mountGame();
      else loadScript(config.gameScript, mountGame);
    }

    // Theme editor: show the popup while its section is selected.
    if (designMode) {
      var sid = root.getAttribute('data-section-id');
      on(document, 'shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === sid) {
          if (variant === 'c') { state.teaser = true; showTeaser(true); }
          open('editor');
        }
      });
      on(document, 'shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === sid) {
          close('editor', false);
          if (teaser) { teaser.hidden = true; teaser.classList.remove('is-in'); }
        }
      });
      root.__vwa = { destroy: destroy };
      return root.__vwa;
    }

    function destroy() {
      state.timers.forEach(function (id) { window.clearTimeout(id); });
      window.clearInterval(state.ticker);
      state.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      document.documentElement.classList.remove('vwa-open');
      if (teaser) teaser.hidden = true;
      if (state.game && state.game.destroy) state.game.destroy();
      root.__vwa = null;
    }
    root.__vwa = { destroy: destroy, open: open, close: close };

    if (preview) {
      later(function () { trigger('preview'); }, 1000);
      return root.__vwa;
    }

    // Eligibility.
    if (!config.enabled) return root.__vwa;
    if (store.get('localStorage', KEY_CLICKED)) return root.__vwa;
    if (excludedPath()) return root.__vwa;
    var now = Date.now();
    if (fromWhatsApp(params)) {
      store.set('localStorage', KEY_SUPPRESS, String(now + FROM_WHATSAPP_DAYS * DAY));
      return root.__vwa;
    }
    var suppressUntil = parseInt(store.get('localStorage', KEY_SUPPRESS) || '0', 10);
    if (suppressUntil > now) return root.__vwa;
    if (hasDiscountCookie()) return root.__vwa;

    // Variant C: the tab stays visible for the rest of the visit until dismissed.
    if (variant === 'c' && store.get('sessionStorage', SKEY_TEASER) === '1') {
      state.fired = true;
      state.viewed = true;
      later(function () { showTeaser(true); }, 600);
      return root.__vwa;
    }

    var last = parseInt(store.get('localStorage', lastKey) || '0', 10);
    var freq = Math.max(1, parseInt(config.frequencyDays, 10) || 7) * DAY;
    if (last && now - last < freq) return root.__vwa;

    // Visible time, cumulated over the pages of the visit.
    var delayMs = Math.max(1, parseInt(config.delay, 10) || 30) * 1000;
    var elapsed = parseInt(store.get('sessionStorage', SKEY_TIME) || '0', 10);
    state.ticker = window.setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      // Re-read the stored value: another page of the visit (bfcache) may have moved it on.
      elapsed = Math.max(elapsed, parseInt(store.get('sessionStorage', SKEY_TIME) || '0', 10)) + 1000;
      store.set('sessionStorage', SKEY_TIME, String(elapsed));
      if (elapsed >= delayMs) {
        window.clearInterval(state.ticker);
        trigger('timer');
      }
    }, 1000);

    // Exit intent (desktop only), not in the first seconds of the page.
    if (config.exitIntent) {
      var armedAt = now + 4000;
      on(document, 'mouseout', function (e) {
        if (state.fired || !isDesktop() || Date.now() < armedAt) return;
        if (!e.relatedTarget && e.clientY <= 0) trigger('exit');
      });
    }

    // Warm the QR encoder on desktop once the page is idle.
    if (isDesktop()) {
      var warm = function () { if (!state.qrDone && window.VaillantQR == null) {
        var s = document.createElement('link');
        s.rel = 'prefetch';
        s.href = config.qrScript;
        document.head.appendChild(s);
      } };
      if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 8000 });
      else later(warm, 5000);
    }

    return root.__vwa;
  }

  function boot() {
    var root = document.querySelector('[data-vwa]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:unload', function (e) {
    var root = document.querySelector('[data-vwa]');
    if (root && root.__vwa && root.getAttribute('data-section-id') === (e.detail && e.detail.sectionId)) root.__vwa.destroy();
  });
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
